export function isValidEmail(email: string) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())
}

const INTERNAL_EMAIL_DOMAINS = [
  'greybullstewardship.com',
  'loop3studio.com',
] as const

function getEmailDomain(email: string): string | null {
  const trimmed = email.trim().toLowerCase()
  const at = trimmed.lastIndexOf('@')
  if (at === -1) return null
  return trimmed.slice(at + 1)
}

export function getAllowedInternalDomains(): readonly string[] {
  return INTERNAL_EMAIL_DOMAINS
}

export function isInternalEmail(email: string): boolean {
  if (!isValidEmail(email)) return false
  const domain = getEmailDomain(email)
  if (!domain) return false
  return getAllowedInternalDomains().includes(domain)
}
